export const ClassEndpoints = {
    getClasses: () => {
        return `${process.env.API_CLUB_CONTENT}/v4/membershipClass`;
    }
};
